import {Filters, PageFilter} from 'filters/types';

import {usePageFilter} from 'filters/contexts/FilterStackProvider';
import {clearFilter} from 'filters/utils';

const createTypeGuardedHook = <K extends keyof Filters>(type: K) => {
  return () => {
    const filter = usePageFilter();

    if (!filter) {
      return {} as Omit<Extract<PageFilter, {_type: K}>, '_type'>;
    }

    if (filter._type !== type) {
      throw new Error(`Expected filter of type ${type}, but got ${filter._type}`);
    }

    return clearFilter(filter);
  };
};

type TypeGuardedHook<K extends keyof Filters> = () => Omit<Extract<PageFilter, {_type: K}>, '_type'>;

export const useDocumentsFilter: TypeGuardedHook<'documents'> = createTypeGuardedHook('documents');
export const usePolicyFilter: TypeGuardedHook<'policy'> = createTypeGuardedHook('policy');
